import type { ContentTypeDto } from "$src/core/models/dto";

const isValidContentType = (type: string): type is ContentTypeDto =>
  ["movies", "series", "episodes", "linear"].includes(type);

export default isValidContentType;
